/* global __SERVER__ */

import React from 'react';
import { func, bool } from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import MainLayout from '@dragonfruit/layouts/MainLayout';
import SEOHead from '@dragonfruit/components/SEOHead';
import LoginLayout from './components/LoginLayout';
import EmailNotVerified from './components/EmailNotVerified';

import { getEmailUnverified } from '@dragonfruit/redux/auth';

const mapStateToProps = state => ({
  emailUnverified: getEmailUnverified(state),
});
function Login({ t, emailUnverified }) {
  const seoComponent = (
    <SEOHead
      path="login"
      title={t('seo:seo.login.title')}
      description={t('seo:seo.login.description')}
    />
  );

  if (__SERVER__) {
    return seoComponent;
  }

  return (
    <MainLayout>
      {seoComponent}
      {emailUnverified ? <EmailNotVerified /> : <LoginLayout />}
    </MainLayout>
  );
}

Login.propTypes = {
  emailUnverified: bool.isRequired,
  t: func.isRequired,
};

export default connect(mapStateToProps)(translate(['seo'])(Login));



// WEBPACK FOOTER //
// ./app/containers/Login/Login.jsx